export type ProgramKey =
  | "students"
  | "parents"
  | "professionals"
  | "group"
  | "individual";

const PROGRAM_ICONS: Record<ProgramKey, string> = {
  students:
    "M2 9.5 12 5l10 4.5-10 4.5L2 9.5Z M6 11.3V16c0 1.7 2.7 3 6 3s6-1.3 6-3v-4.7 M22 9.5V15",
  parents:
    "M10.5 6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1 5 0Z M3.5 21v-5a4.5 4.5 0 0 1 9 0v5 M19 11a2 2 0 1 1-4 0 2 2 0 1 1 4 0Z M14 21v-2a3 3 0 0 1 6 0v2",
  professionals:
    "M5 7h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2 M3 13h18",
  group:
    "M14.5 7a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1 5 0Z M7.5 20v-1.5a4.5 4.5 0 0 1 9 0V20 M6.8 10a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 1 1 3.6 0Z M2 19v-.5a3 3 0 0 1 3-3h.5 M20.8 10a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 1 1 3.6 0Z M22 19v-.5a3 3 0 0 0-3-3h-.5",
  individual:
    "M4 4h10a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9l-3 3v-3H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z M16 8h4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-1v3l-3-3h-3a2 2 0 0 1-2-2",
};

/** Decorative bold-line icon that fades into the corner of a program card. */
export const ProgramWatermark = ({
  program,
  size = "md",
}: {
  program: ProgramKey;
  size?: "md" | "lg";
}) => (
  <svg
    className={`gw-card__watermark gw-card__watermark--${size}`}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d={PROGRAM_ICONS[program]}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
